function formatMoney(cents) {
  cents = parseInt(cents, 10);

  // Check if Shopify.formatMoney is available (multi-currency safe)
  if (window.Shopify && typeof Shopify.formatMoney === "function") {
    return Shopify.formatMoney(cents, window.Shopify.currency.active_format || window.Shopify.money_format);
  }

  // Fallback if Shopify.formatMoney doesn’t exist
  let amount = (cents / 100).toFixed(2);

  // Detect country currency
  let currency = (window.Shopify && Shopify.currency && Shopify.currency.active) 
                   ? Shopify.currency.active 
                   : "USD";

  switch (currency) {
    case "AED": return `Dhs ${amount}`;
    case "USD": return `$${amount}`;
    case "EUR": return `€${amount}`;
    case "GBP": return `£${amount}`;
    case "INR": return `₹${amount}`;
    // add more if needed
    default: return `${amount} ${currency}`;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.getElementById("cart-drawer");
  const overlay = document.querySelector(".cart-drawer-overlay");
  const cartItemsContainer = document.getElementById("cart-items");
  const cartTotal = document.getElementById("cart-total");
  const cartCount = document.getElementById("cart-count");
  const closeBtn = document.getElementById("close-cart-drawer");

  function openDrawer() {
    cartDrawer.classList.add("show");
    cartDrawer.classList.remove("hidden");
  }
  function closeDrawer() {
    cartDrawer.classList.remove("show");
    cartDrawer.classList.add("hidden");
  }

  closeBtn.addEventListener("click", closeDrawer);

  async function loadCart() {
  const res = await fetch("/cart.js");
  const cart = await res.json();

  cartItemsContainer.innerHTML = "";

  if (cart.items.length === 0) {
    cartItemsContainer.innerHTML = `
      <div class="cart-empty">
        <p>Your cart is empty.</p>
      </div>
    `;
    cartTotal.textContent = "DHS 0.00";
    cartCount.textContent = 0;
    document.querySelector(".cart-drawer-header h3").textContent = "Your Cart (0)";
    return;
  }

  cart.items.forEach(item => {
    const div = document.createElement("div");
    div.className = "cart-item";

    const fallbackImage = "//cdn.shopify.com/s/images/themes/product-1.png";
    const itemImage = (item.image && item.image.trim() !== "")
      ? item.image
      : fallbackImage;

    div.innerHTML = `
      <img src="${itemImage}" alt="${item.title}" />
      <div class="cart-item-info">
        <p class="cart-item-title">${item.title}</p>
        <p class="cart-item-price">${formatMoney(item.line_price)}</p>
        <div class="cart-qty">
          <button data-action="decrease" data-key="${item.key}">-</button>
          <input type="text" value="${item.quantity}" readonly />
          <button data-action="increase" data-key="${item.key}">+</button>
          <button class="remove-item" data-action="remove" data-key="${item.key}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
                 aria-hidden="true" focusable="false" class="icon icon-remove">
              <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
              <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
      </div>
    `;
    cartItemsContainer.appendChild(div);
  });

  cartTotal.textContent = formatMoney(cart.total_price);
  cartCount.textContent = cart.item_count;
  document.querySelector(".cart-drawer-header h3").textContent = `Your Cart (${cart.item_count})`;
}


  // Add-to-cart form intercept
  // document.querySelectorAll(".product-form").forEach(form => {
  //   form.addEventListener("submit", async (e) => {
  //     e.preventDefault();
  //     const formData = new FormData(form);
  //     await fetch("/cart/add.js", { method: "POST", body: formData });
  //     await loadCart();
  //     openDrawer();
  //   });
  // });

  // document.querySelectorAll(".product-form").forEach(form => {
  //   form.addEventListener("submit", async (e) => {
  //     e.preventDefault();
  //     const formData = new FormData(form);
  //     const chosenVariantId = formData.get("id"); 
  //     await fetch("/cart/add.js", { method: "POST", body: formData });
      
  //     if (chosenVariantId === "52399014117739") {
  //       // Add the extra product
  //       await fetch("/cart/add.js", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           id: 52413395272043,
  //           quantity: 1
  //         })
  //       });
  //     }
  //     await loadCart();
  //     openDrawer();
  //   });
  // });


  // Handle qty & remove (delegate, also works inside SVG)
  cartItemsContainer.addEventListener("click", async (e) => {
    const actionBtn = e.target.closest("[data-action]");
    if (!actionBtn) return;

    const key = actionBtn.dataset.key;
    const action = actionBtn.dataset.action;

    if (action === "remove") {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      return loadCart();
    }

    const res = await fetch("/cart.js");
    const cart = await res.json();
    const item = cart.items.find(i => i.key === key);
    if (!item) return;

    let newQty = item.quantity;
    if (action === "increase") newQty++;
    if (action === "decrease") newQty--;

    if (newQty < 1) newQty = 0;

    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: newQty })
    });

    loadCart();
  });

  loadCart();
});